/* eslint-disable react/no-array-index-key */

import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import discoveryData from '../Discovery/data';

import {
  article,
  articleContainer,
  fullWidth,
  imageContainer,
  link,
  section,
  tile,
} from './styles.module.css';

const Masonry = ({ collections, showLess, location, countryCode }) => (
  <section className={fullWidth}>
    {collections
      .filter((id, index) => index < 12 || !showLess)
      .map((id, index) => {
        const hasChild =
          Object.keys(discoveryData)
          .map(key => ({ key, value: discoveryData[key] }))
          .find(c => c.value.filters && c.value.filters[id]);
        const child = hasChild ? hasChild.value.filters[id] : undefined;
        const parent = discoveryData[id] || hasChild.value;
        const href = `${countryCode ? `/${countryCode.toLowerCase()}/` : '/'}${parent.slug}-events${child ? `/${child.slug}` : ''}${location ? `/in-${location.slug}` : ''}`;
        return (
          <article className={articleContainer} key={`masonry-article-${index}`}>
            <div className={imageContainer}>
              <Link
                to={href}
                style={{ backgroundImage: `url(${child ? child.image.small : parent.image.small})` }}
                className={tile}
              >
                <h2 className={link}>{ child ? child.title : parent.title}{location ? ` In ${location.name}` : null}</h2>
              </Link>
            </div>
          </article>
        );
      })}
  </section>
);


export default Masonry;

Masonry.propTypes = {
  /*
   * An array of arrays for each grid of collection data.
   */
  collections: PropTypes.arrayOf(PropTypes.string).isRequired,
  /*
   * An object containing the location of the slug
   */
  location: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
  }),
  /*
   * Boolean to determine whether to show first four events plus discover button.
   */
  showLess: PropTypes.bool,
  /*
   * countryCode of the browser.
   */
  countryCode: PropTypes.string,
};

Masonry.defaultProps = {
  showLess: false,
  location: undefined,
  countryCode: undefined,
};



// WEBPACK FOOTER //
// ./app/src/components/Masonry/index.jsx